<template>
	<div class="login-wrapper">
		<div class="header">
			<img class="logo" src="~assets/logo.png" />
			<div class="name">欢迎使用扶馨陪诊运维端</div>
		</div>
		<div class="login-box">
			<div class="frm-tit">您好，请登录!</div>
			<div class="frm-row">
				<input type="text" class="in-text" v-model="frmUserInfo.username" placeholder="请输入您的账号" />
			</div>
			<div class="frm-row">
				<input type="password" class="in-text" v-model="frmUserInfo.password" placeholder="请输入您的密码" />
			</div>
			<div class="frm-btn" @click="handlerLogin">立即登录</div>
		</div>
	</div>
</template>

<script>
import { userLogin } from "@/api/login";
import md5 from 'js-md5';

	export default{
		name: 'Login',
		data(){
			return{
				frmUserInfo: {
					username: '',
					password: ''
				}
			}
		},
		methods: {
			handlerLogin: function(){
				if(this.frmUserInfo.username == ''){
					this.$toast('请输入账号')
					return
				}
				if(this.frmUserInfo.password == ''){
					this.$toast('请输入密码')
					return
				}

        var data = {
          username: this.frmUserInfo.username,
          password: md5(this.frmUserInfo.password)
        }
        userLogin(data).then(res => {
          localStorage.setItem('accessToken', res.result.accessToken);
          this.$router.push({ path: '/home' })
        })
				// this.$toast.loading({
				//   message: '登录中...',
				//   forbidClick: true,
				//   loadingType: 'spinner',
				// });
				
			}
		},
		mounted: function(){
			
		}
	}
</script>

<style scoped>
.login-wrapper{ height: 100vh; position: relative;}
.header{ height: 4.8rem; box-sizing: border-box; background: rgba(63, 88, 253, 0.8); display: flex; justify-content: center; align-items: center; flex-direction: column;}
.header>.logo{ width: 1.2rem; height: 1.2rem; border-radius: 0.2rem; margin: 0 0 0.3rem;}
.header>.name{ height: 0.48rem; line-height: 0.48rem; font-size: 0.32rem; font-weight: 600; color: #FFF;}
.login-box{ position: fixed; bottom: 0; left: 0; right: 0; height: calc(100vh - 4.6rem + 0.6rem); box-sizing: border-box; background: #FFF; padding: 0.4rem 0.4rem 0; box-shadow: 0 0 0.06rem rgba(0, 0, 0, 0.1); border-top-left-radius: 0.4rem; border-top-right-radius: 0.4rem;}
.frm-tit{ height: 1rem; line-height: 1rem; color: #000; font-weight: 600; font-size: 0.4rem;}
.frm-row{ height: 1rem; padding: 0.28rem 0 0; box-sizing: border-box; position: relative;}
.frm-row::after{ position: absolute; content: ''; left: 0; right: 0; bottom: 0; height: 1px; background: #e1e1e1;}
.frm-row>.in-text{ width: 100%; max-width: calc(7.5rem - 0.8rem); height: 0.72rem; line-height: 0.72rem;}
.frm-btn{ margin: 0.4rem 0 0; height: 0.88rem; line-height: 0.88rem; text-align: center; color: #FFF; font-size: 0.32rem; border-radius: 0.88rem; background: #3f58fd;}
</style>